import React from 'react';
import Input from './Input'
import { IField } from '../../shared/interfaces';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { getTheme, ISeparatorStyles, Label, mergeStyleSets, Separator, Sticky, StickyPositionType } from '@fluentui/react';
import { Indici_FormMode } from '../../shared/enums';

const separatorStyles: Partial<ISeparatorStyles> = {
    root: {
        margin: '0px 0px 18px'
    }
}

const theme = getTheme();
const classNames = mergeStyleSets({
    wrapper: {
        position: 'relative',
        height: '100%',
    },
    pane: {
    },
    sticky: {
    },
    textContent: {
    },
});



export interface DynamicFormProps {
    fields?: IField[]
    separatorIndexes?: number[]
    extraCssClass?: string
    onInputChangedHandler: (newField: IField) => void
    label?: string
    labelIndexes?: number[]
    formMode?: Indici_FormMode
}

const DynamicForm: React.FunctionComponent<DynamicFormProps> = (props) => {

    return (

        <React.Fragment>
            {
                props.fields?.map((field, index) => {
                    let autofocus = index === 0;
                    let showSeparator = props.separatorIndexes && props.separatorIndexes.findIndex(el => el == index) >= 0;
                    let showLabel = props.labelIndexes && props.labelIndexes.findIndex(el => el == index) >= 0;

                    return (
                        <React.Fragment key={index}>

                            {field.isStickyField &&
                                <Sticky stickyPosition={StickyPositionType.Header}>
                                    <div role="heading" aria-level={1} className={classNames.sticky}>
                                        <Input
                                            autofocus={false} /* va migliorato*/
                                            field={field}
                                            key={'field' + index}
                                            changed={(newField) => props.onInputChangedHandler(newField)}
                                            formMode={props.formMode}
                                        />
                                    </div>
                                </Sticky>
                            }
                            {!field.isStickyField &&
                                <Input
                                    autofocus={false} /* va migliorato*/
                                    field={field}
                                    key={'field' + index}
                                    changed={(newField) => props.onInputChangedHandler(newField)}
                                    formMode={props.formMode}
                                />
                            }
                            {showSeparator &&

                                <Separator styles={separatorStyles} key={'separator' + index} />
                            }

                            {showLabel &&
                                <Label style={{ marginBottom: '25px', fontSize: '16px' }}>{props.label}</Label>
                            }

                        </React.Fragment>
                    );
                })

            }
        </React.Fragment>
    );
};


export default DynamicForm;


